import { useEffect, useState } from "react";
import API from "../../lib/api";
import { Input } from "../ui/input";
import { Badge } from "../ui/badge";

export function RecentErrors() {
  const [data, setData] = useState(null);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(null);

  useEffect(() => {
    const t = setTimeout(async () => {
      try { const { data: d } = await API.get("/platform/system-status/errors", { params: { q, limit: 50 } }); setData(d); } catch { /* shown empty */ }
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div className="rounded-lg border border-border bg-card p-3" data-testid="system-errors">
      <div className="flex items-center justify-between gap-2 mb-2">
        <div className="text-xs font-semibold">Recent server errors <span className="font-normal text-muted-foreground">· {data?.count_24h ?? 0} in 24 h</span></div>
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search path, message, type…" className="h-7 w-56 text-xs" data-testid="system-errors-search" />
      </div>
      {!data?.items?.length ? <p className="text-xs text-muted-foreground" data-testid="system-errors-empty">No server errors recorded{q ? " for that search" : ""} — good.</p> : (
        <div className="divide-y divide-border/60 max-h-80 overflow-auto">
          {data.items.map((e, i) => (
            <div key={`${e.at}-${i}`} className="py-1.5 text-xs" data-testid="system-error-row">
              <button type="button" className="w-full text-left flex items-start gap-2" onClick={() => setOpen(open === i ? null : i)} data-testid="system-error-toggle">
                <span className="text-muted-foreground tabular-nums shrink-0">{new Date(e.at).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })}</span>
                <Badge className="text-[9px] bg-red-100 text-red-700 shrink-0">{e.status}</Badge>
                <span className="font-mono truncate">{e.method} {e.path}</span>
                <span className="text-muted-foreground truncate ml-auto">{e.type ? `${e.type}: ` : ""}{e.message}</span>
              </button>
              {open === i && e.trace && <pre className="mt-1 p-2 rounded bg-muted text-[10px] whitespace-pre-wrap max-h-48 overflow-auto" data-testid="system-error-trace">{e.trace}</pre>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
